import { Box } from '@mantine/core';

/**
 * Konteyner ichidagi yuklanish ko'rsatkichi — SEZILARLI, lekin halaqit bermaydigan.
 *
 * Avvalgi variant `LoadingOverlay` edi: blur 1, shaffoflik 0.2 va kichkina spinner.
 * Amalda u DEYARLI KO'RINMASDI — foydalanuvchi filtrni o'zgartirib, hech narsa
 * sodir bo'lmadi deb o'ylardi. Ayni paytda uni kuchaytirish (qorong'i qatlam,
 * katta spinner) ma'lumotni yopib qo'yardi va har filtrda ekran "o'chib-yonardi".
 *
 * Yechim — konteynerning TEPASIDAGI ingichka yugurik chiziq:
 *  • ko'z darhol ilg'aydi (harakat statik shaffoflikdan ancha sezilarli);
 *  • ma'lumotni yopmaydi — eski jadval o'qilaverdi;
 *  • `position: absolute` — layout sakramaydi, balandlik o'zgarmaydi.
 *
 * Ota element `pos="relative"` bo'lishi shart (Mantine `Card`/`SectionCard` da bor).
 */
export function FetchOverlay({ visible }: { visible: boolean }) {
  return (
    <Box
      aria-hidden={!visible}
      style={{
        position: 'absolute',
        insetInline: 0,
        top: 0,
        height: 3,
        overflow: 'hidden',
        zIndex: 5,
        borderRadius: '3px 3px 0 0',
        // Ko'rinmaganda DOM'dan olib tashlamaymiz: qayta mount animatsiyani
        // qayta boshlab, tez-tez filtrlashda chiziq "sakrab" ketardi.
        opacity: visible ? 1 : 0,
        transition: 'opacity 150ms ease',
        pointerEvents: 'none',
      }}
    >
      <Box
        style={{
          height: '100%',
          width: '40%',
          borderRadius: 3,
          background: 'var(--mantine-color-brand-6, var(--mantine-primary-color-filled))',
          animation: visible ? 'sata-fetch-slide 1.1s ease-in-out infinite' : 'none',
        }}
      />
      <style>{`
        @keyframes sata-fetch-slide {
          0%   { transform: translateX(-100%); }
          100% { transform: translateX(250%); }
        }
        @media (prefers-reduced-motion: reduce) {
          /* Harakatni o'chirganlar uchun — chiziq statik, lekin baribir ko'rinadi */
          @keyframes sata-fetch-slide { 0%, 100% { transform: translateX(0); } }
        }
      `}</style>
    </Box>
  );
}
